const countries = [
  { label: "United States of America", value: "US" },
  { label: "Canada", value: "CA" },
];

export default countries;
